<template>
  <v-dialog
    v-model="modalShow"
    fullscreen
    hide-overlay
    transition="slide-up-down"
    class="purchase-history-dialog"
  >
    <v-card class="p-3">
      <div class="d-flex">
        <font-awesome-icon
          @click="close"
          icon="times"
          class="ml-auto f-xl"
        ></font-awesome-icon>
      </div>
      <div class="f-bold mb-6">
        {{ $t("coupon_note_title") || "REDEEM VOUCHER" }}
      </div>
      <div class="coupon-container">
        <div class="text-center">
          <qrcode-vue
            :value="
              $store.state.theme.qr_code == 'Telephone'
                ? profile.telephone
                : profile.member_id
            "
            :size="160"
            class="mt-7"
            render-as="svg"
            background="transparent"
          />
          <div>
            <span
              data-lang="telephone"
              v-if="$store.state.theme.qr_code == 'Telephone'"
              >{{ $t("telephone") }}
            </span>
            <span data-lang="member_id" v-else>{{ $t("member_id") }} </span>
            :
            {{
              $store.state.theme.qr_code == "Telephone"
                ? profile.telephone
                : profile.member_id
            }}
          </div>

          <!-- <small class="error">{{ $t("coupon_note") }} </small> -->
        </div>
        <div class="voucher-code">
          <div style="margin-left: 7px">
            {{ $t("voucher_active") || "Voucher Active" }}
          </div>
          <Barcode :value="code" />

          <div style="margin-left: 7px">
            <span data-lang="coupon_code">{{ $t("coupon_code") }}</span> :
            {{ code ? code : "-" }}
          </div>
        </div>
        <!-- <div class="timer-countdown mt-2" v-if="markUse">
          <div data-lang="qr_count_time">{{ $t("qr_count_time") }}</div>
          <div>
            {{ countTime }}
          </div>
        </div> -->
        <div class="countdown-time mt-2" v-if="markUse">
          <div data-lang="qr_count_time" class="text-center">
            {{ $t("qr_count_time") }}&nbsp;{{ countTime }}
          </div>
        </div>
        <div class="coupon-remark">
          {{
            $t("coupon_remark") ||
            "You cannot redeem another voucher while this one is still active"
          }}
        </div>

        <!-- <div v-if="allow">
          <c-btn @click="$emit('use')" variant="confirm-primary" block
            ><span data-lang="confirm_used">{{ $t("confirm_used") }}</span>
          </c-btn>
        </div> -->
        <div>
          <c-btn @click="close" variant="outline-primary" block>
            <span data-lang="close_window">{{ $t("back") }}</span></c-btn
          >
        </div>
      </div>
    </v-card>
    <div></div>

    <hr />
  </v-dialog>
</template>

<script>
var x;
import Barcode from "@/components/other/Barcode.vue";
export default {
  props: {
    code: {
      required: true,
      type: String,
      default: ""
    },
    name: {
      required: false,
      type: String
    },
    allow: {
      required: false
    },
    countTime: {
      required: false,
      default: "00:00"
    },
    markUse: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  components: {
    Barcode
    // VueQrcode
  },
  data() {
    return {
      modalShow: false,
      profile: { ...this.$store.state.shortProfile }
    };
  },
  mounted() {},
  watch: {
    modalShow(value) {
      if (!value) clearInterval(x);
    }
  },
  methods: {
    show() {
      this.modalShow = true;
      // this.countTimer();
    },
    close() {
      this.modalShow = false;
      this.$emit("close");
      clearInterval(x);
    },
    countTimer() {
      function padZero(value) {
        value = String(value);
        return value.length == 1 ? "0" + value : value;
      }
      var diff = this.$moment().add(30, "minutes").valueOf();
      if (this.$cookies.isKey("coupon")) {
        let cookie = this.$cookies.get("coupon");
        let cache = cookie.findIndex(
          el => el.id == this.$route.params.privilegeId
        );
        if (cache != -1) {
          diff = cookie[cache].end;
        } else {
          this.$cookies.set(
            "coupon",
            cookie.push({
              id: this.$route.params.privilegeId,
              start: this.$moment(),
              end: this.$moment().add(30, "minutes").valueOf()
            })
          );
        }
      } else {
        this.$cookies.set(
          "coupon",
          JSON.stringify([
            {
              id: this.$route.params.privilegeId,
              start: this.$moment(),
              end: this.$moment().add(30, "minutes").valueOf()
            }
          ])
        );
      }
      var countDownDate = diff;
      x = setInterval(() => {
        var now = this.$moment().valueOf();
        var distance = countDownDate - now;
        var minutes = padZero(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        );
        var seconds = padZero(Math.floor((distance % (1000 * 60)) / 1000));
        if (distance < 0) {
          return clearInterval(x);
          // this.countTime = "EXPIRED";
        }
        this.$nextTick(() => {
          this.countTime = minutes + " : " + seconds;
        });
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-body {
  margin: auto;
  text-align: center;
}
.image-logo {
  width: 100%;
  height: 100%;
}
.btn-outline {
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
}
.dot {
  display: inline-block;
  top: 6%;
  position: absolute;
  width: 20px;
  height: 45px;
  border: 10px solid #000;
  border-left: 0;
  background-color: #000;
}
.error {
  color: red;
}
.dot-left {
  left: 0;
  border-bottom-right-radius: 100px;
  border-top-right-radius: 100px;
}
.dot-right {
  border-bottom-left-radius: 100px;
  border-top-left-radius: 100px;
  right: 0;
}
.border-behind {
  border-top: 4px dashed #dfdfdf;
  position: absolute;
  top: 50%;
  width: 100%;
  left: 0;
}
.line-clamp-2 {
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  // display: -webkit-box;
}
.qr-width-70 {
  width: 80% !important;
  height: 80% !important;
  padding: 0.5rem 0;
}
.voucher-code {
  width: 75%;
  margin: 0 auto;
  margin-top: auto;
  margin-bottom: auto;
}
.coupon-remark {
  width: 75%;
  text-align: center;
  margin: auto auto 15px auto;
}
.coupon-container {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  height: 100%;
}
.countdown-time {
  // color: red;
  // font-size: 18px;
  font-weight: 600;
  margin-bottom: 1rem;
  width: 75%;

  margin: auto auto 15px auto;
}
</style>
